import { render } from "./Autocomplete.vue?vue&type=template&id=453486a3&scoped=true"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=453486a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-453486a3"

export default script